import { ChangeEvent, useState } from 'react';

import { Typography, Box, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import type { AnyAction } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';

import { ActionDialog } from '../../../../../../../components';
import * as actions from '../../../../../../../store/actions';

interface DevicesDialogProps {
	open?: boolean;
	handleClose?: (updated: boolean) => void;
	onUpdateAccess?: (
		organisationId?: number | string,
		devicesAccess?: boolean,
		commandsAccess?: boolean
	) => unknown;
	organisationId?: number | string;
	hasDevicesAccess?: boolean;
	hasCommandsAccess?: boolean;
}

const DevicesDialog = (props: DevicesDialogProps) => {
	const { open, handleClose, onUpdateAccess, organisationId, hasDevicesAccess, hasCommandsAccess } =
		props;
	const { t } = useTranslation();

	const [devicesAccess, setDevicesAccess] = useState(hasDevicesAccess);
	const [commandsAccess, setCommandsAccess] = useState(hasCommandsAccess);

	const handleUpdate = async () => {
		await onUpdateAccess?.(organisationId, devicesAccess, commandsAccess);
		handleClose?.(true);
	};

	const handleDevices = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.checked;
		setDevicesAccess(value);
	};

	const handleCommands = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.checked;
		setCommandsAccess(value);
	};

	return (
		<ActionDialog
			actionButtonProps={{
				action: handleUpdate,
				text: t('ui.confirm'),
			}}
			handleClose={() => handleClose?.(false)}
			loading={false}
			open={open}
			title={t('ui.label.devices')}
		>
			<Box alignItems='center' display='flex' justifyContent='space-between'>
				<Typography variant='h6'>
					{t('views.organisationManagement.devices.devicesDialog.showDevices')}
				</Typography>
				<Switch checked={devicesAccess} onChange={handleDevices} />
			</Box>
			<Box alignItems='center' display='flex' justifyContent='space-between'>
				<Typography variant='h6'>
					{t('views.organisationManagement.commands.showCommands')}
				</Typography>
				<Switch checked={commandsAccess} onChange={handleCommands} />
			</Box>
		</ActionDialog>
	);
};

const mapDispatchToProps = (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
	return {
		onUpdateAccess: (
			organisationId?: number | string,
			devicesAccess?: boolean,
			commandsAccess?: boolean
		) => dispatch(actions.updateAccess(organisationId, devicesAccess, commandsAccess)),
	};
};

export default connect(null, mapDispatchToProps)(DevicesDialog);
